function init() {

	var mainNav = document.getElementById("main-nav"),
		mainMenuToggler = document.getElementById("primary-nav-toggler"),
		htmlTag = document.getElementsByTagName("html")[0];

	if(mainMenuToggler){
		mainMenuToggler.addEventListener("click", () => {

			let isOpen = mainNav.classList.contains("open");
			if (isOpen) {
				mainMenuToggler.setAttribute("aria-expanded", "false");
				mainNav.classList.remove("open");
				htmlTag.classList.remove("no-scroll");
			} else {
				mainMenuToggler.setAttribute("aria-expanded", "true");
				mainNav.classList.add("open");
				htmlTag.classList.add("no-scroll");
			}
		});
	}

	subMenuVisibility();
	
}

function subMenuVisibility(){
	var hasChildrenItems = document.querySelectorAll('#primary-menu > .menu-item-has-children > a, #lang-menu > .menu-item-has-children > a'),
		hasChildrens = document.querySelectorAll('#primary-menu .menu-item-has-children, #lang-menu .menu-item-has-children'),
		mainHeader = document.getElementById('main-header');

	if(hasChildrenItems.length > 0){
		window.utils.forEach(hasChildrenItems, function (index, hasChildrenItem) {
			hasChildrenItem.addEventListener("click", function (e) {
				console.log(e);
				e.preventDefault();

				var lisContainer = hasChildrenItem.parentElement.querySelector('.sub-menu');
				var lis = lisContainer.children;

				window.utils.forEach(hasChildrens, function (index, hasChildren) {

					if(hasChildrenItem.parentElement != hasChildren){
						hasChildren.classList.remove('open');
						hasChildren.classList.remove('close'); 
					}

				});

				if(hasChildrenItem.parentElement.classList.contains('open')){
					hasChildrenItem.parentElement.classList.remove('open');
					hasChildrenItem.parentElement.classList.add('close');
					mainHeader.classList.remove('open');

					window.utils.forEach(lis, function (index, li) {
						li.classList.remove('active');
					});

				} else {

					
					hasChildrenItem.parentElement.classList.add('open');
					hasChildrenItem.parentElement.classList.remove('close');
					mainHeader.classList.add('open');

					window.utils.forEach(lis, function (index, li) {
						setTimeout(() => {
							li.classList.add('active');
						}, index * "300");
					});
					
				}
			})
		});
	}

}


export default { init };
